const getters = {
  getTncHeaderFooterOptions(state) {
    return state.tncHeaderFooterOptions;
  },
  getSchemes(state) {
    return state.schemes;
  },
  getGeneralFormData(state) {
    return state.generalMasterData;
  },
  getCreateSchemeForm(state) {
    return state.createSchemeForm;
  },
  getGroupDataList(state) {
    return state.groups;
  },
  getCreatePartnerGroupData(state) {
    return state.createPartnerGroupData;
  },
  getPartnerGroups(state) {
    return state.partnerGroups;
  },
  getProductGroups(state) {
    return state.productGroups;
  },
  getSingleGroupData(state) {
    return state.singleGroupData;
  },
  getGroupTypeDetails(state) {
    return state.groupTypeDetails;
  },
  getLoader(state) {
    return state.loader;
  },
  getProductGroupMasterData(state) {
    return state.createProductGroupData;
  },
  getProductLevelData(state) {
    return state.productLevelData;
  },
  getschemeProgramMasterData(state) {
    return state.schemeProgramMasterData;
  },
  getEligibilityMasterData(state) {
    return state.eligibilityMasterData;
  },
  getSelectedListData(state) {
    return state.selectedPatnerDetail;
  },
  getTargetMasterData(state) {
    return state.targetMasterData;
  },
  getPayoutMasterData(state) {
    return state.payoutMasterData;
  },
  getvalidationLinkData(state) {
    return state.vallidationLinkData;
  },
  getTargetLinkData(state) {
    return state.targetLinkData;
  },
  getGeneralSectionData(state) {
    return state.generalSectionData;
  },
  getPartnerGeoData(state) {
    return state.partnerGeo;
  },
  getEligibilityRangeStartDate(state) {
    return state.eligibilityRangeStartDate;
  },
  getSlabMinValue(state) {
    return state.slabMinValue;
  },
  getBizSlabMinValue(state) {
    return state.bizSlabMinValue;
  },
  getDemoDeductionStartDateValue(state) {
    return state.demoDeductionStartDateValue;
  },
  getSchemeProgramData(state) {
    return state.schemeProgramData;
  },
  getViewTargetData: (state) => {
    return state.viewTarget;
  },
  getTargetExceptiontData: (state) => {
    return state.targetException;
  },
  getSchemeExceptionSelectedPlans: (state) => {
    return state.schemeExceptionSelectedPlans;
  },
  getSelectedPlanListRows: (state) =>{
    return state.selectedPlanListRows;
  },
  getSchemeExceptionMasterDropDown: (state) => {
    return state.schemeExceptionMasterDropDown;
  },
  getbugetSubCatItem: (state) => {
    return state.bugetSubCatItem;
  },
  getPartnerTypeFromLists: (state) => {
    return state.partnerTypeFromLists;
  },
  getPartnerCodeLists: (state) => {
    return state.partnerCodeListsSellerExclusion;
  },
  getPartnerTypeToLists: (state) => {
    return state.partnerTypeToLists;
  },
  getDemoDeductionDropDownOptions: (state) => {
    return state.demoDropDownOptionsData
  },
  getStoreConditionEligibity: (state) => {
    return state.storeConditionEligibityArr
  },
  getIsAddModifyAddProgramValue: (state) => {
    return state.isAddModifyAddProgramValue
  },
  getpurposeSelecItem: (state) => {
    return state.purposeSelecItem
  },
  getStoreAddProgramForReportPayout: (state) => {
    return state.storeAddProgramForReportPayoutData
  },

};

export default getters;
